module.exports = __webpack_public_path__ + "static/img/comprehensive02.0cb4e866.png";